// Core Imports
import {
  backendErrors,
  type Prefix,
  type BackendErrorKeys,
} from '@/core/constants/backend-error'

export function displayBackendError<
  P extends Prefix,
  K extends BackendErrorKeys<P>,
>(prefix: P, type: K, errorType?: string): string {
  const message = backendErrors[prefix][type]

  if (typeof message === 'function') {
    return (message as (arg?: string) => string)(errorType)
  }

  return message as string
}
